const initAccordions = () => {
  const accordionBlocks = Array.from(document.querySelectorAll('.accordion'));
  accordionBlocks.forEach(initSingleAccordionBlock);
};

const initSingleAccordionBlock = element => {
  const items = element.querySelectorAll('.accordion-item');

  items.forEach(item => {
    const header = item.querySelector('.accordion-item-header');
    const body = item.querySelector('.accordion-item-body');
    const isMultiple = `${element.dataset?.multiple}` === 'true';
    body.style.maxHeight = 0;

    header.addEventListener('click', event => {
      if (item.classList.contains('open')) {
        item.classList.remove('open');
        body.style.maxHeight = 0;
      } else {
        if (!isMultiple) {
          items.forEach(i => {
            i.querySelector('.accordion-item-body').style.maxHeight = 0;
            i.classList.remove('open');
          });
        }
        item.classList.add('open');
        body.style.maxHeight = `${body.scrollHeight}px`;
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', initAccordions);
